var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-vv-value-path": "model", "data-vv-as": _vm.label } },
    [
      _vm.label
        ? _c("label", { staticClass: "theme-input__label" }, [
            _vm._v(_vm._s(_vm.label))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.basic
        ? _c("editor", {
            attrs: {
              init: {
                menubar: false,
                relative_urls: false,
                remove_script_host: false,
                force_br_newlines: true,
                force_p_newlines: false,
                forced_root_block: "",
                plugins: "autoresize spellchecker paste",
                autoresize_min_height: 300,
                autoresize_max_height: 580,
                toolbar:
                  "undo redo | bold italic underline strikethrough " +
                  "| alignleft aligncenter alignright alignjustify | outdent indent | spellchecker",
                skin: false,
                spellchecker_callback: _vm.spellcheck,
                spellchecker_wordchar_pattern: /\b[^\d\W]+\b/gi,
                spellchecker_languages: "",
                setup: function(editor) {
                  editor.on("blur", function() {
                    var newContent = editor.getContent()
                    // Fire an event to let its parent know
                    _vm.$emit("change", newContent)
                  })
                },
                content_style: _vm.css
              }
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          })
        : _c("editor", {
            attrs: {
              init: {
                relative_urls: false,
                remove_script_host: false,
                height: _vm.editorHeight,
                force_br_newlines: true,
                force_p_newlines: false,
                forced_root_block: "",
                plugins:
                  "code textcolor colorpicker lists image link media hr table spellchecker directionality wordcount paste",
                toolbar:
                  "code | insertfile undo redo | styleselect | bold italic underline strikethrough forecolor backcolor " +
                  "| alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media | hr table " +
                  "| spellchecker",
                skin: false,
                spellchecker_callback: _vm.spellcheck,
                spellchecker_wordchar_pattern: /\b[^\d\W]+\b/gi,
                spellchecker_languages: "",
                setup: function(editor) {
                  editor.on("blur", function() {
                    var newContent = editor.getContent()
                    // Fire an event to let its parent know
                    _vm.$emit("change", newContent)
                  })
                },
                content_style: _vm.css
              }
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model"
          }
        ],
        attrs: { type: "hidden", name: _vm.name, id: _vm.id },
        domProps: { value: _vm.model },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.model = $event.target.value
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f178d422", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f178d422","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeWysiwyg.vue
// module id = 638
// module chunks = 1